import React from 'react'
import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { Loader, useFinstrongStore, useGlobalCopyStore } from '../../../common'

import TotalCard from '../shared/TotalCard'
import Transactions from '../shared/Transactions'

const SpendingTabContent: React.FC = () => {
  const { finstrong: copy } = useGlobalCopyStore()
  const {
    isSpendingInitialized,
    healthScore,
    allTransactions,
    loadSpendTransactions,
    loadDebtSpend,
  } = useFinstrongStore()

  React.useEffect(() => {
    if (!isSpendingInitialized) {
      loadSpendTransactions().finally()
      loadDebtSpend().finally()
    }
  }, [isSpendingInitialized])

  const transactions = React.useMemo(() => {
    const spendTransactions = allTransactions.spend.map((item) => item.transaction)
    const debtSpendTransactions = allTransactions.debtSpend.map((item) => item.transaction)
    return [...spendTransactions, ...debtSpendTransactions]
  }, [allTransactions.spend, allTransactions.debtSpend])

  if (!isSpendingInitialized) return <Loader />

  return (
    <Stack gap={16} sx={{ p: 16 }}>
      <TotalCard
        balance={healthScore.ninety_day_spend / 90}
        title={copy.key_indicators_save.drawer_daily_spend}
      />
      <Transactions amountColor="text.primary" transactions={transactions} />
    </Stack>
  )
}

export default observer(SpendingTabContent)
